module.exports = __webpack_public_path__ + "static/media/bannerImage3-s.5d45b149.jpg";